/**
 * 封装请求数据API
 */
module.exports = {
    /**
     * 发送请求
     */
    fetch: function({ url = '', data = {}, type = 'GET', dataType = 'json', timeout = 10000 } = {}) {
        data.t = new Date().getTime();

        let promise = $.ajax({
            url: url,
            data: data,
            type: type,
            dataType: dataType,
            timeout: timeout
        });
        
        // 请求成功
        promise.done((res) => {
            // ... success do something
            if (res.errcode == "1000001" || res.errcode == '1000004') {
                // usertoken登录失效
                $.channel.emit('authorize'); 
            }
        });

        return promise;
    }
};



// WEBPACK FOOTER //
// ./js/base/http.js